import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import FontAwesome from 'react-fontawesome';
import { fetchWeeklyProgramItem } from '../../dashboard/common/actions';
import {
	loadBookingOptions, selectPaymentType, startEnrolment, selectJoinWaitingList
} from '../../dashboard/booking/actions';
import { getChild } from '../../dashboard/reducer';

class ClassDetails extends Component {

	componentDidMount() {
		if (!this.props.authInitializing) {
			this.initBookingOptions();
		}
	}

	componentWillReceiveProps(nextProps) {
		// wait for token refresh to complete, as booking options are reset on logout if refresh token fails
		if (this.props.authInitializing && !nextProps.authInitializing) {
			this.initBookingOptions();
		}
	}

	initBookingOptions() {
		const { startDate, centerId, programId, lessonType, paymentTypeId, isPrepaid, annualPaymentLength, isBonusLesson } = this.props;

		this.props.fetchWeeklyProgramItem(centerId, programId);
		this.props.loadBookingOptions({
			programId,
			date: startDate,
			childId: null,
			lessonType,
			centerId
		});

		if (paymentTypeId) {
			this.props.selectPaymentType({ paymentTypeId, isPrepaid, isBonusLesson, annualPaymentLength });
		} else {
			this.props.selectJoinWaitingList();
			this.props.history.push('/register', { from: '/booking/child' });
		}
	}

	render() {
		const { weeklyProgramItem, childrenPaymentTypes, errorMessage } = this.props;
		if (!weeklyProgramItem || !weeklyProgramItem.grade.name || !weeklyProgramItem.center.name || !weeklyProgramItem.term.name || (!childrenPaymentTypes && !errorMessage)) {
			return <div style={{ textAlign: 'center', fontSize: '16px', color: '#0071ac' }}>
				<FontAwesome name='spinner' spin size='3x' />
			</div>;
		}

		// start enrolment process once all required data is loaded
		if (childrenPaymentTypes) {
			const { franchisor, centerId, programId, startDate, paymentTypeId } = this.props;
			const childPaymentOptions = childrenPaymentTypes.find(x => !x.child);
			const paymentOption = childPaymentOptions && childPaymentOptions.paymentTypes.find(x => x.id === paymentTypeId);

			if (paymentOption) {
				this.props.startEnrolment({
					centerId,
					programId,
					startDate,
					paymentTypeId,
					currency: franchisor.currency,
					quantity: paymentOption && paymentOption.quantity,
					unitPrice: paymentOption && paymentOption.unitPriceAmount,
					total: paymentOption && paymentOption.totalAmount,
					lesson: weeklyProgramItem
				});
			}
		}
		return <Redirect to={{
			pathname: '/register',
			state: { from: '/booking/child' }
		}} />;
	}
}

const mapStateToProps = (state, ownProps) => {
	const centerId = Number(ownProps.match.params.centerId);
	const programId = Number(ownProps.match.params.programId);
	const lessonType = !ownProps.match.params.lessonType || ownProps.match.params.lessonType === 'all' ? '' : ownProps.match.params.lessonType;
	const startDate = ownProps.match.params.startDate;
	const paymentTypeId = Number(ownProps.match.params.paymentType);
	const annualPaymentLength = Number(ownProps.match.params.annualPaymentLength);
	const isPrepaid = ownProps.match.params.isPrepaid === '1' || ownProps.match.params.isPrepaid === 'true';
	const isBonusLesson = ownProps.match.params.isBonusLesson === '1' || ownProps.match.params.isBonusLesson === 'true';

	const {
		configuration: { franchisor },
		auth,
		booking: { childrenPaymentTypes, errorMessage },
		entities: { centers, grades, terms, weeklyProgram }
	} = state;

	let weeklyProgramItemDeepLoaded = weeklyProgram[programId];
	if (weeklyProgramItemDeepLoaded) {
		weeklyProgramItemDeepLoaded.grade = grades[weeklyProgramItemDeepLoaded.gradeId] || { name: '', subGrades: [] };
		weeklyProgramItemDeepLoaded.center = centers[weeklyProgramItemDeepLoaded.centerId] || { name: '' };
		weeklyProgramItemDeepLoaded.term = terms[weeklyProgramItemDeepLoaded.termId] || { name: '', schoolYear: '' };
	}

	return {
		authInitializing: auth.initializing,
		centerId,
		programId,
		lessonType,
		startDate,
		paymentTypeId,
		annualPaymentLength,
		isPrepaid,
		isBonusLesson,
		franchisor,
		weeklyProgramItem: weeklyProgramItemDeepLoaded,
		errorMessage,
		childrenPaymentTypes: (childrenPaymentTypes && childrenPaymentTypes.length > 0) ? childrenPaymentTypes.map(c => ({
			child: getChild(state.parent, c.childId),
			paymentTypes: c.paymentTypes,
			errorMessage: c.errorMessage,
			joinWaitingList: c.joinWaitingList,
			isLocked: c.isLocked
		})) : null
	};
};

export default connect(mapStateToProps, {
	fetchWeeklyProgramItem,
	loadBookingOptions,
	selectPaymentType,
	startEnrolment,
	selectJoinWaitingList
})(withTranslation()(ClassDetails));